import { useState } from "react";
import "./Checkout.css";
import SiteHeader, { SiteHeaderAccountActions } from "./SiteHeader";
import { apiSend, errorMessage } from "./api";
import { getPlan, CONTACT, formatPrice } from "./plans";

function Checkout({ plan, user, onBack, onGoHome, onGoLogin, onGoGestion, onLogout, onMenuNavigate }) {
  const [starting, setStarting] = useState(false);
  const [payError, setPayError] = useState("");
  // Compatibilité : accepte soit un id de plan, soit { planId, billing }.
  const planId = typeof plan === "string" ? plan : plan?.planId;
  const billing = (typeof plan === "object" && plan?.billing) || "monthly";
  const details = getPlan(planId);

  const BILLING = {
    monthly: { price: details.monthly, priceFull: details.monthlyFull, period: "/ mois", badge: null },
    annual: { price: details.annual, priceFull: details.annualFull, period: "/ an", badge: details.annualBadge },
  };
  const { price, priceFull, period, badge } = BILLING[billing] || BILLING.monthly;

  // Le montant prélevé est décidé par le serveur à partir de plan_id : on ne
  // lui envoie donc que le choix de l'offre, jamais un prix.
  const startPayment = async () => {
    setStarting(true);
    setPayError("");
    try {
      const { url } = await apiSend("/api/billing/checkout-session", "POST",
        { plan_id: planId, billing }, "Impossible d'ouvrir le paiement");
      window.location.href = url;
      return; // la redirection est en cours : ne pas réactiver le bouton
    } catch (e) {
      setPayError(errorMessage(e, "Impossible d'ouvrir le paiement"));
    }
    setStarting(false);
  };

  return (
    <div className="checkout">
      {/* Même header que la landing : marque + connexion/gestion, où qu'on soit */}
      <SiteHeader onLogoClick={onGoHome || onBack} onBack={onBack}>
        <SiteHeaderAccountActions
          user={user}
          onGoLogin={onGoLogin}
          onGoGestion={onGoGestion}
          onLogout={onLogout}
          onMenuNavigate={onMenuNavigate}
        />
      </SiteHeader>

      <main className="checkout-main">
        <div className="checkout-card">
          <span className="rc-offer-num">
            {details.num} · {details.nickname}
          </span>
          <h1>{details.name}</h1>
          <div className="checkout-price">
            <span className="checkout-amount">{formatPrice(price)} €</span>
            <span className="checkout-period">{period}</span>
            {priceFull && (
              <span className="rc-strike checkout-price-full">
                {formatPrice(priceFull)} €
              </span>
            )}
          </div>
          {badge && (
            <span className="rc-badge rc-badge-soft checkout-badge">
              {badge}
            </span>
          )}

          <div className="checkout-summary">
            <div className="checkout-summary-row">
              <span>{details.name}</span>
              <span>
                {formatPrice(price)} € {period}
              </span>
            </div>
            <div className="checkout-summary-row checkout-summary-note">
              <span>{details.setupNote}</span>
            </div>
            <div className="checkout-summary-row checkout-summary-total">
              <span>Total</span>
              <span>
                {formatPrice(price)} € {period}
              </span>
            </div>
          </div>

          {/* Le paiement suppose un compte rattaché à un commerce : sans
              session, on ne peut ni identifier le payeur ni créer son
              abonnement. On renvoie donc vers la connexion. */}
          {user && user.organization_id ? (
            <div className="checkout-pay">
              {payError && <p className="checkout-pay-error">{payError}</p>}
              <button
                className="rc-btn rc-btn-primary checkout-pay-btn"
                onClick={startPayment}
                disabled={starting}
              >
                {starting ? "Ouverture du paiement..." : "Payer par prélèvement SEPA"}
              </button>
              <p className="checkout-pay-note">
                Vous serez redirigé vers Stripe pour saisir votre IBAN et signer
                le mandat de prélèvement. Le premier prélèvement est confirmé
                sous 2 à 5 jours ouvrés. Résiliable à tout moment.
              </p>
            </div>
          ) : (
            <div className="checkout-placeholder">
              <p className="checkout-placeholder-title">
                {user ? "Aucun commerce rattaché à votre compte." : "Connectez-vous pour souscrire."}
              </p>
              <p className="checkout-placeholder-sub">
                {user
                  ? "Contactez-nous pour rattacher votre commerce à votre compte, et le paiement par prélèvement sera disponible."
                  : "La souscription se fait depuis votre compte. Vous pouvez aussi nous joindre directement."}
              </p>
              <div className="checkout-contact">
                {!user && onGoLogin && (
                  <button className="rc-btn rc-btn-primary" onClick={onGoLogin}>
                    Se connecter
                  </button>
                )}
                <a href={`tel:${CONTACT.phone.replace(/ /g, "")}`} className="rc-btn rc-btn-outline">
                  {CONTACT.phone}
                </a>
                <a href={`mailto:${CONTACT.email}`} className="rc-btn rc-btn-outline">
                  {CONTACT.email}
                </a>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default Checkout;
